<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book goes out to my friends. You have become my family and I wish you nothing but joy. Sharon, for the better part of a decade you have become my sister. I love you. Tina, you showed me a lot in the short time we have been friends and I miss you every day. You are an inspiration and your character gave ideas for several stories. And last but by no means least, Laura. Thank you for being my grammar Nazi. You always supported me, and I am grateful. Thank you for being my friend and I love you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?555544e0